// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ng-dialog/css/ngDialog.css
// module id = irI0
// module chunks = 1 2